// extracted by mini-css-extract-plugin
module.exports = {"image":"Edit__image___2Nte5"};